import { useSecurityOwnershipWithEntitiesRetrieveSuspense } from "gen/endpoints/security-ownership/security-ownership";
import { useMemo } from "react";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const useCommittingEntities = () => {
  const { fundFamilyId } = useRequiredStringParams();
  const { data: securityOwnerships } =
    useSecurityOwnershipWithEntitiesRetrieveSuspense(fundFamilyId);

  return useMemo(() => {
    const owningEntitiesWithNonZeroCommitment = new Set(
      securityOwnerships
        .filter((ownership) => Number(ownership.commitment_amount) > 0)
        .map((ownership) => ownership.owning_entity_id),
    );

    return owningEntitiesWithNonZeroCommitment;
  }, [securityOwnerships]);
};
